export const ORDER_EXPORT_FIELDS = [
  { id: 'recipientName', label: 'Nome do destinatário', group: 'Contato' },
  { id: 'phone', label: 'Telefone', group: 'Contato' },
  { id: 'fullAddress', label: 'Endereço completo', group: 'Endereço' },
  { id: 'cep', label: 'CEP', group: 'Endereço' },
  { id: 'street', label: 'Logradouro', group: 'Endereço' },
  { id: 'streetNumber', label: 'Número', group: 'Endereço' },
  { id: 'complement', label: 'Complemento', group: 'Endereço' },
  { id: 'neighborhood', label: 'Bairro', group: 'Endereço' },
  { id: 'city', label: 'Cidade', group: 'Endereço' },
  { id: 'state', label: 'Estado', group: 'Endereço' },
  { id: 'referencePoint', label: 'Ponto de referência', group: 'Endereço' },
  { id: 'latitude', label: 'Latitude', group: 'Localização' },
  { id: 'longitude', label: 'Longitude', group: 'Localização' },
  { id: 'geocodeStatus', label: 'Situação da localização', group: 'Localização' },
  { id: 'receivedAt', label: 'Data do pedido', group: 'Pedido' },
  { id: 'quantity', label: 'Quantidade', group: 'Pedido' },
  { id: 'stickerModels', label: 'Modelos de adesivo', group: 'Pedido' },
  { id: 'status', label: 'Situação do pedido', group: 'Pedido' },
  { id: 'attemptCount', label: 'Tentativas de entrega', group: 'Pedido' },
  { id: 'batchName', label: 'Remessa', group: 'Operação' },
  { id: 'routeName', label: 'Rota', group: 'Operação' },
  { id: 'driverName', label: 'Entregador', group: 'Operação' },
  { id: 'stopSequence', label: 'Ordem da parada', group: 'Operação' },
] as const

export type OrderExportFieldId = typeof ORDER_EXPORT_FIELDS[number]['id']

export const DEFAULT_ORDER_EXPORT_FIELDS: OrderExportFieldId[] = [
  'recipientName', 'phone', 'fullAddress', 'neighborhood', 'cep', 'status',
]

export const ORDER_EXPORT_PRESETS: Array<{ label: string; fields: OrderExportFieldId[] }> = [
  { label: 'Endereços', fields: ['fullAddress', 'cep', 'neighborhood', 'city', 'state', 'referencePoint'] },
  { label: 'Contatos', fields: ['recipientName', 'phone'] },
  { label: 'Operação', fields: ['recipientName', 'phone', 'fullAddress', 'status', 'batchName', 'routeName', 'driverName', 'stopSequence'] },
  { label: 'Tudo', fields: ORDER_EXPORT_FIELDS.map((field) => field.id) },
]
